import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Search, Filter } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";

const mockLogs = [
  { id: "1", action: "create", entity: "deal", user: "john@acme.com", workspace: "Acme Investments", timestamp: "2 min ago" },
  { id: "2", action: "update", entity: "property", user: "jane@smith.com", workspace: "Smith Holdings", timestamp: "15 min ago" },
  { id: "3", action: "delete", entity: "task", user: "bob@realestate.com", workspace: "Real Estate Group", timestamp: "1 hour ago" },
  { id: "4", action: "create", entity: "transaction", user: "john@acme.com", workspace: "Acme Investments", timestamp: "2 hours ago" },
];

const actionColors = {
  create: "default",
  update: "secondary",
  delete: "destructive",
} as const;

export default function AdminAuditLogs() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold text-foreground">Audit Logs</h1>
        <p className="text-muted-foreground mt-1">Track all system activity</p>
      </div>

      {/* Search & Filter */}
      <div className="flex gap-4">
        <div className="relative flex-1 max-w-md">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground" />
          <Input placeholder="Search logs..." className="pl-10" />
        </div>
        <Button variant="outline">
          <Filter className="w-4 h-4 mr-2" />
          Filters
        </Button>
      </div>

      {/* Logs List */}
      <Card className="shadow-soft">
        <CardHeader>
          <CardTitle>Recent Activity</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="space-y-4">
            {mockLogs.map((log) => (
              <div
                key={log.id}
                className="flex items-center justify-between p-4 rounded-lg border border-border hover:bg-accent/50 transition-colors"
              >
                <div className="flex items-center gap-4">
                  <Badge variant={actionColors[log.action as keyof typeof actionColors]}>
                    {log.action}
                  </Badge>
                  <div>
                    <p className="font-medium">
                      {log.entity.charAt(0).toUpperCase() + log.entity.slice(1)}
                    </p>
                    <p className="text-sm text-muted-foreground">
                      by {log.user} in {log.workspace}
                    </p>
                  </div>
                </div>
                <span className="text-sm text-muted-foreground">{log.timestamp}</span>
              </div>
            ))}
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
